module.exports = __webpack_public_path__ + "img/20190715154206506.d3a80eb5.png";